import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import {
  OwnerListRequestBody,
  OwnerListResponse,
} from "../../core/api/requests/owner/list/types";
import {
  OwnerDetailRequestBody,
  OwnerDetailResponse,
} from "../../core/api/requests/owner/detail/types";
import {
  OwnerCreateRequestBody,
  OwnerCreateResponse,
} from "../../core/api/requests/owner/create/types";
import {
  OwnerEditRequestBody,
  OwnerEditResponse,
} from "../../core/api/requests/owner/edit/types";
import {
  OwnerDeleteRequestBody,
  OwnerDeleteResponse,
} from "../../core/api/requests/owner/delete/types";

const actionCreator = actionCreatorFactory("@@Owner");

export const ownerActions = {
  fetchOwners: actionCreator.async<
    CommonAsyncType<OwnerListResponse> & OwnerListRequestBody,
    OwnerListResponse
  >("FETCH_OWNERS"),
  getOwnerDetails: actionCreator.async<
    CommonAsyncType<OwnerDetailResponse> & OwnerDetailRequestBody,
    OwnerDetailResponse
  >("GET_OWNER_DETAILS"),
  createNewOwner: actionCreator.async<
    CommonAsyncType<OwnerCreateResponse> & OwnerCreateRequestBody,
    OwnerCreateResponse
  >("CREATE_NEW_OWNER"),
  updateOwner: actionCreator.async<
    CommonAsyncType<OwnerEditResponse> & OwnerEditRequestBody & { id: string },
    OwnerEditResponse
  >("UPDATE_OWNER"),
  deleteOwner: actionCreator.async<
    CommonAsyncType<OwnerDeleteResponse> & OwnerDeleteRequestBody & { id: string },
    {}
  >("DELETE_OWNER"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
